import useLogger from "./useLogger";
export default function useTrackUnsuccessfulRegistration() {
  const logger = useLogger();
  return (userObj) => {
    logger.trackEvent("Unsuccessful Registration", { ...userObj });
  };
}
